import Router from 'next/router';

/**
 * Replace-style navigation for the AMS auth views. Module scope over the
 * next/router singleton keeps the identity referentially stable forever —
 * the views' contract; a useCallback over useRouter() would inherit the
 * router object's per-render instability.
 */
export const navigateReplace = (path: string): void => {
  void Router.replace(path);
};
